/* eslint-disable @next/next/no-img-element */
import { useEffect } from 'react'
import { parseLocale } from 'lib/constants/localization'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { onPageEnter } from 'lib/tracking/pageEnter'
import Meta from 'components/modules/SEO/Meta'
import { useRouter } from 'next/router'
import { getReferrerScreen } from 'lib/formatting/url'
import _useTranslation from 'lib/hooks/_useTranslation'
import { getCountryConfig } from 'lib/constants/countryconfig'
import VariantProLandingPage from 'lib/features/Pro/VariantProLandingPage'

const PlusPlan = () => {
    const { t } = _useTranslation('plusPlan')
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)

    useEffect(() => {
        onPageEnter()
    }, [])

    return (
        <div>
            <Meta title={t('plusPlan/pageTitle')} description={t('plusPlan/pageDescription')} />
            <VariantProLandingPage referrerScreen={referrerScreen} />
        </div>
    )
}

export const getStaticProps: GetStaticProps = async (props) => {
    const parsedLocale = parseLocale(props.locale)
    const { hasPlusPlan } = getCountryConfig(parsedLocale.countryCode)

    if (!hasPlusPlan)
        return {
            notFound: true,
        }

    return {
        props: {
            ...(await serverSideTranslations(parseLocale(props.locale).interfaceLanguageCode, [
                'common',
                'plusPlan',
                'auth',
                'knows',
            ])),
        },
    }
}

export default PlusPlan
